import { formatDate } from "@/core/helpers/DatetimeConverter";

const Tournaments = {
  Plural: "Tournaments",
  Single: "Tournament",
  ModalForm: false,
  DefaultSorting: "startAt",
  DefaultSortingType: "desc",
  Columns: [
    { name: "", label: "#", type: "counter" },
    {
      name: "id",
      dbName: "id",
      label: "ID",
      sortable: true,
      required: true,
      type: "text",
    },
    {
      name: "name",
      dbName: "name",
      label: "Name",
      sortable: true,
      required: true,
      type: "text",
    },
    {
      name: "startAt",
      dbName: "startAt",
      label: "Start Date",
      sortable: true,
      type: "date",
      format: (row: any) => formatDate(row.startAt),
    },
    {
      name: "endAt",
      dbName: "endAt",
      label: "End Date",
      sortable: true,
      type: "date",
      format: (row: any) => formatDate(row.endAt),
    },
    {
      name: "coins",
      dbName: "coins",
      label: "Entry Cost",
      sortable: true,
      type: "text",
    },
    {
      name: "isActive",
      dbName: "isActive",
      label: "Active",
      sortable: true,
      type: "text",
      format: (row: any) => (row.isActive ? "Yes" : "No"),
    },
  ],
  Filters: [],
  PrimaryKey: "id",
  Actions: {
    addLink: "/tournaments/add/",
    editLink: "/tournaments/edit/",
    deleteLink: true,
  },
};

export default Tournaments;
